import Api from './api-core/api-core';

const apiChuchoteurs = new Api(process.env.CONFIG.API_CHUCHOTEURS, {cache: 'no-cache'});

export default apiChuchoteurs;
